const whost = window.location.host;
const isDev = whost.startsWith("dev");

const isLocal = whost.startsWith("localhost");

const host = isDev ? "dev" : "app";

export { isDev, host, isLocal };
